import React, { useState } from 'react';
import { motion } from 'framer-motion';
import '../styles/NewsLetterForm.css';

const MAILCHIMP_POST_URL = process.env.REACT_APP_MAILCHIMP_URL;

export default function NewsletterSignup() {
  const [status, setStatus] = useState('idle');
  const [message, setMessage] = useState('');

 const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');
    setMessage('');

    const formData = new FormData(e.target);
    const url = `${MAILCHIMP_POST_URL}&c=?`;

    try {
      await fetch(url, {
        method: 'POST',
        body: formData,
        mode: 'no-cors', // Mailchimp's embedded form requires this
      });
      // Mailchimp with no-cors always returns an opaque response
      // so we assume success if the request doesn't throw.
      setStatus('success');
      setMessage("Thank you for subscribing! Please check your email to confirm.");
      e.target.reset();
    } catch (error) {
      setStatus('error');
      setMessage('Something went wrong. Please try again.');
    }
  };

  // Animation variants for a staggered entrance
  const sectionVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.15 },
    },
  };

  const childVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
  };

  return (
    <div className="newsletter-section-wrapper">
      <motion.div
        id="newsletter"
        className="newsletter-section-container"
        variants={sectionVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
      >
        <motion.span variants={childVariants} className="section-super-title">
          Stay Connected
        </motion.span>
        <motion.h2 variants={childVariants} className="section-heading">
          Join the News Letter
        </motion.h2>
        <motion.p variants={childVariants} className="section-subheading">
          Get exclusive updates, behind-the-scenes content, and be the first to know about new releases.
        </motion.p>

        <motion.form
          variants={childVariants}
          className="newsletter-form"
          onSubmit={handleSubmit}
        >
          <div className="form-row">
            <input type="text" name="FNAME" placeholder="First Name" className="input" required />
            {/* NEW: Last Name Field */}
            <input type="text" name="LNAME" placeholder="Last Name" className="input" required />
            <input type="email" name="EMAIL" required placeholder="Email Address *" className="input" />
          </div>
          <button type="submit" className="submit-btn" disabled={status === 'loading'}>
            {status === 'loading' ? 'Submitting…' : 'Subscribe'}
          </button>

          {message && (
            <p className={`form-message ${status}`}>{message}</p>
          )}
        </motion.form>
      </motion.div>
    </div>
  );
}
